import styles from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import { positionMap } from '@/constants/powerStream';
import { useGlobal } from '@/utils/useGlobal';

const { EFPic } = createEFPic('/media/power-stream/detail/pc/');

export default function Position() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('powerstream.detail.position');
    const { locale } = useRouter();
    const LOCAL_SITES: string[] = ['it'];

    const positionData: any = positionMap[locale] || positionMap.uk;

    return (
        <div className={`${styles.position} position`}>
            <div className="position-box">
                {LOCAL_SITES.includes(locale) && (
                    <div className="position-row disclaimer">
                        {t('disclaimer')}
                    </div>
                )}
                <div className="position-row">
                    <div className={`common-card ${positionData[0]?.name}-box`}>
                        <div className="box-img">
                            <EFPic className={`${positionData[0]?.name}-img`} name={[`${positionData[0]?.key}.webp`, `${positionData[0]?.key}.jpg`]} />
                        </div>
                        <p className={`${positionData[0]?.name}-text box-text`}>{t(positionData[0]?.key)}</p>
                    </div>
                    <div className={`common-card ${positionData[1]?.name}-box`}>
                        <div className="box-img">
                            <EFPic className={`${positionData[1]?.name}-img`} name={[`${positionData[1]?.key}.webp`, `${positionData[1]?.key}.jpg`]} />
                        </div>
                        <p className={`${positionData[1]?.name}-text box-text`}>{t(positionData[1]?.key)}</p>
                    </div>
                </div>
                {!LOCAL_SITES.includes(locale) && (
                    <div className="position-row">
                        <div className={`common-card ${positionData[2]?.name}-box`}>
                            <div className="box-img">
                                <EFPic className={`${positionData[2]?.name}-img`} name={[`${positionData[2]?.key}.webp`, `${positionData[2]?.key}.jpg`]} />
                            </div>
                            <p className={`${positionData[2]?.name}-text box-text`}>{t(positionData[2]?.key)}</p>
                        </div>
                        <div className={`common-card ${positionData[3]?.name}-box`}>
                            <div className="box-img">
                                <EFPic className={`${positionData[3]?.name}-img`} name={[`${positionData[3]?.key}.webp`, `${positionData[3]?.key}.jpg`]} />
                            </div>
                            <p className={`${positionData[3]?.name}-text box-text`}>{t(positionData[3]?.key)}</p>
                        </div>
                        <div className={`common-card ${positionData[4]?.name}-box`}>
                            {positionData[4]?.key === 'upgradable' ? (
                                <div className="upgradable-text box-text">
                                    {t.rich('upgradable', {
                                        small: (text1: string) => <p className="small-text">{text1}</p>,
                                        big: (text2: string) => <p className="big-text">{text2}</p>,
                                    })}
                                    <span className="upgrand-svg" />
                                </div>
                            ) : (
                                <>
                                    <div className="box-img">
                                        <EFPic
                                            className={`${positionData[4]?.name}-img`}
                                            name={[`${positionData[4]?.key}.webp`, `${positionData[4]?.key}.jpg`]}
                                        />
                                    </div>
                                    <p className={`${positionData[4]?.name}-text box-text`}>{t(positionData[4]?.key)}</p>
                                </>
                            )}
                        </div>
                    </div>
                )}
                {LOCAL_SITES.includes(locale) && (
                    <div className="position-row">
                        <div className={`common-card ${positionData[4]?.name}-box`}>
                            {positionData[4]?.key === 'upgradable' ? (
                                <div className="upgradable-text box-text">
                                    {t.rich('upgradable', {
                                        small: (text1: string) => <p className="small-text">{text1}</p>,
                                        big: (text2: string) => <p className="big-text">{text2}</p>,
                                    })}
                                    <span className="upgrand-svg" />
                                </div>
                            ) : (
                                <>
                                    <div className="box-img">
                                        <EFPic
                                            className={`${positionData[4]?.name}-img`}
                                            name={[`${positionData[4]?.key}.webp`, `${positionData[4]?.key}.jpg`]}
                                        />
                                    </div>
                                    <p className={`${positionData[4]?.name}-text box-text`}>{t(positionData[4]?.key)}</p>
                                </>
                            )}
                        </div>
                        <div className={`common-card ${positionData[2]?.name}-box`}>
                            <div className="box-img">
                                <EFPic className={`${positionData[2]?.name}-img`} name={[`${positionData[2]?.key}.webp`, `${positionData[2]?.key}.jpg`]} />
                            </div>
                            <p className={`${positionData[2]?.name}-text box-text`}>{t(positionData[2]?.key)}</p>
                        </div>
                    </div>
                )}
            </div>
            {!LOCAL_SITES.includes(locale) && <p className="footer-note">{t('disclaimer')}</p>}
            {['de', 'eu'].includes(locale as string) && <p className="footer-note">{t('note')}</p>}
        </div>
    );
}
